import React, { useEffect, useState } from 'react';
import Hero from '../components/Layout/Hero'; // Assuming you have a Hero component
// import Video from '../assets/Nature hero.mp4'; // Path to your video file
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import GenderCollectionSection from '../components/Products/GenderCollectionSection';
import NewArrivals from '../components/Products/NewArrivals';

import ProductGrid from '../components/Products/ProductGrid';
import ProductDetails from '../components/Products/ProductDetails';
import FeaturesSection from '../components/Products/FeaturesSection';
import {useDispatch, useSelector} from "react-redux";
import {fetchProductsByFilters} from '../../redux/slices/productsSlice';
import axios from 'axios';
import Marquee from '../components/Layout/marquee.jsx';





const Home = () => {
  const dispatch = useDispatch();
  const {products, loading, error} = useSelector((state) => state.products);
  const [bestSellerProduct, setBestSellerProduct] = useState(null);

  useEffect(() => {
    // Fetch product for a specific collection
    dispatch(
      fetchProductsByFilters({
        gender: "Unisex",
        category: "Essentials",
        limit: 8,
      })
    );
    // Fetch best seller product
    const fetchBestSeller = async () => {
      try {
        const response = await axios.get(`${import.meta.env.VITE_BACKEND_URL}/api/products/best-seller`);
        setBestSellerProduct(response.data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchBestSeller();
  }, [dispatch]);

  return (
    <div>
  <Hero />
  <GenderCollectionSection />
  <NewArrivals />
 

  {/* Best Seller / Handpicked Section */}
  <h2 className="text-3xl text-center font-bold mb-4">Best Seller</h2>
  {bestSellerProduct ? (<ProductDetails productId={bestSellerProduct._id} />) : (
    <p className="text-center">Loading Best Seller Product ... </p>
  )}
      
{/*   <ProductDetails /> */}

  {/* <div className="container mx-auto">
    <h2 className="text=3xl text-center font-bold mb-4">
      Top Wears for Men
    </h2>
    <ProductGrid products={products} loading={loading} error={error} />
    </div> */}








      <div className="container bg-black md:rounded-md mx-auto px-4 py-16">
  {/* Heading */}
  <div className="text-center mb-12">
    <h2 className="text-3xl md:text-4xl  font-black text-white tracking-wider uppercase mb-4">
      Explore Our Collections
    </h2>
    <p className="text-white text-sm tracking-wide">
      Curated pieces for those who refuse to follow
    </p>
  </div>

  {/* Category Grid */}
  <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-12">
    {/* Category Card 1 */}
    <a href="https://www.veshheon.in/collections/all" className="group">
      <div className="relative overflow-hidden rounded-md bg-gray-50 border border-gray-200 aspect-square mb-4 transition-all duration-300 group-hover:border-black">
        <img 
          src="https://res.cloudinary.com/dmrlotfsv/image/upload/t_VESHH-EON_WEBSITE/OVERSIZED_SHIRT_NAVY_BLUE_kk5ahr" 
          alt="T-Shirts"
          className="w-80 h-80 mx-auto object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <h3 className="text-center text-white text-sm font-medium tracking-widest uppercase">
        New Launches
      </h3>
    </a>

    {/* Category Card 2 */}
    <a href="https://www.veshheon.in/collections/Essentials" className="group">
      <div className="relative overflow-hidden rounded-md bg-gray-50 border border-gray-200 aspect-square mb-4 transition-all duration-300 group-hover:border-black">
        <img 
          src="https://res.cloudinary.com/dmrlotfsv/image/upload/t_VESHH-EON_WEBSITE/init_post-06_ivsplc" 
          alt="Hoodies"
          className="w-80 h-80 mx-auto object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <h3 className="text-center text-white text-sm font-medium tracking-widest uppercase">
        Essentials
      </h3>
    </a>

    {/* Category Card 3 */}
    <a href="https://www.veshheon.in/collections/Concrete%20Jungle" className="group">
      <div className="relative overflow-hidden rounded-md bg-gray-50 border border-gray-200 aspect-square mb-4 transition-all duration-300 group-hover:border-black">
        <img 
          src="https://res.cloudinary.com/dmrlotfsv/image/upload/t_VESHH-EON_WEBSITE/Raven_Black_ybdpmp" 
          alt="Oversized"
          className="w-80 h-80 mx-auto object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <h3 className="text-center text-white text-sm font-medium tracking-widest uppercase">
        Concrete Jungle
      </h3>
    </a>

    {/* Category Card 4 */}
    <a href="https://www.veshheon.in/collections/WinterWear" className="group">
      <div className="relative overflow-hidden rounded-md bg-gray-50 border border-gray-200 aspect-square mb-4 transition-all duration-300 group-hover:border-black">
        <img 
          src="https://res.cloudinary.com/dmrlotfsv/image/upload/t_VESHH-EON_WEBSITE/Oversized_Hoodie_Black_sahsms" 
          alt="Shirts"
          className="w-80 h-80 mx-auto object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <h3 className="text-center text-white text-sm font-medium tracking-widest uppercase">
        Winter Wear
      </h3>
    </a>
  </div>

  {/* View All Button */}
  <div className="text-center">
    <a 
      href="https://www.veshheon.in/collections/all"
      className="inline-block bg-black text-white px-12 py-4 text-xs font-semibold tracking-widest uppercase border-2 border-white rounded-md hover:bg-white hover:text-black transition-all duration-300"
    >
      View All Collections
    </a>
  </div>
</div>







      
    <FeaturesSection />
{/*       <Marquee /> */}
  </div>
    
  )
}

export default Home;
